var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container",attrs:{"id":"app"}},[_c('router-view',{key:_setup.locale,attrs:{"language":_setup.locale},on:{"changeLanguage":_setup.changeLanguage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }